import {BookingTransactionStatus} from "./constants/booking-transaction-constants";

let getDisplayValue = (value) => {
    return BookingTransactionStatus[value] ? BookingTransactionStatus[value].supplierInvoiceStatusGroup.label : value;
};

export default getDisplayValue;
